// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatInterest } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { COUNTRIES_CODES: { ES } } = require('constants/countries');

class ContractLabelDeposit extends React.Component {

    componentDidMount() {
        const {
            immContract,
            immDeposits,
            immProfile,
            localState,
            actions: {
                refreshFunction,
                termsAndCondsLegalWindowSetParams,
                updateCardDetails,
                updateConfirmationCheckboxes,
                updateDepositProduct,
            },
        } = this.props;
        const { card_details, deposit_product, confirmationCheckboxes } = localState;
        if (immContract.get('name_contract') === 'depositrenewal') {
            const depositId = immContract.get('renewalOrExpiredDepositId');
            const deposit = immDeposits.getIn(['byId', depositId]);
            const expirationDate = deposit.getIn(['impositionList', 'byId']).first().get('expirationDate');
            const day = DateHelper.getDay(expirationDate)
            const month = moment().month(DateHelper.getMonth(expirationDate) - 1).locale(immProfile.get('mainLanguage')).format('MMM') 
            const year = DateHelper.getFullYear(expirationDate)
            const expirationCardDetails = card_details.find(component => component.id === 'startDate');
            
            if (expirationCardDetails) {
              expirationCardDetails.injectedStringValues = [day, month, year];
              expirationCardDetails.value = 'contractsView-renewalDateValue'
              expirationCardDetails.originalValue = expirationDate
            }
            const todayDate = DateHelper.todayDate();
            const todayDay = DateHelper.getDay(todayDate);
            const todayMonth = moment().month(DateHelper.getMonth(todayDate) - 1).locale(immProfile.get('mainLanguage')).format('MMM')
            const todayYear = DateHelper.getFullYear(todayDate);
            const startDateCardDetails = card_details.find(component => component.id === 'applicationDate');
            if (startDateCardDetails) {
              startDateCardDetails.injectedStringValues = [todayDay, todayMonth, todayYear];
              startDateCardDetails.value = 'contractsView-renewalDateValue'
            }
        }
        const chosenDeposit = immContract.getIn(['mainDeposits', 'data']).toJS();
        card_details.find(x => x.id === 'tin').value = chosenDeposit.depositConfig.tin;
        card_details.find(x => x.id === 'tae').value = chosenDeposit.depositConfig.tae;
        card_details.find(x => x.id === 'installment').value = 'contractsView-installmentValueKey';
        card_details.find(x => x.id === 'installment').injectedStringValues = [chosenDeposit.depositConfig.months]
        deposit_product.preContractualAlias = chosenDeposit.precontractualProcessType;
        deposit_product.contractualAlias = chosenDeposit.contractualProcessType;
        deposit_product.type = chosenDeposit.type;
        deposit_product.tin = chosenDeposit.depositConfig.tin;
        deposit_product.tae = chosenDeposit.depositConfig.tae;
        deposit_product.months = chosenDeposit.depositConfig.months;
        deposit_product.subtype = chosenDeposit.subtype;
        deposit_product.standard = chosenDeposit.standard;
        deposit_product.name = chosenDeposit.name;
        deposit_product.startDate = chosenDeposit.depositConfig.pictureStartDate;
        deposit_product.max = chosenDeposit.depositConfig.max;
        deposit_product.min = chosenDeposit.depositConfig.min;
        deposit_product.context = chosenDeposit.context;
        deposit_product.wrapup = chosenDeposit.wrapup;
        deposit_product.depositIdentify = chosenDeposit.depositIdentify;
        deposit_product.ccPrecontractualPreviewer = chosenDeposit.ccPrecontractualPreviewer;
        updateDepositProduct(deposit_product);
        updateCardDetails(card_details);
        updateConfirmationCheckboxes(confirmationCheckboxes);
        refreshFunction && refreshFunction();
        termsAndCondsLegalWindowSetParams(chosenDeposit.precontractualProcessType, chosenDeposit.contractualProcessType);
    }

    buildLabel(){
        const { immContract, immProfile }=this.props
        const originCountry = immProfile.get('originCountry')
        const depositsAllowed = immContract.getIn(['mainDeposits', 'data']);
        const name = depositsAllowed.toJS().name;
        const context = depositsAllowed.toJS().context;
        const data = depositsAllowed.toJS().depositConfig;
        const tae = formatInterest(data.tae);
        const tin = formatInterest(data.tin);

        const isSameTinTae = tin === tae
        const isPassportCountry = ![ES].includes(originCountry)
        const keyTinTae = isSameTinTae || isPassportCountry ? 'contractsView-contractsView_selectedDepositLabel' : 'contractsView-contractsView_selectedDepositFullLabel'
        const injectedStringsTinTae = [
            formatText(`${context}-${name}`),
            ...(isSameTinTae || isPassportCountry ? [] : tae),
            tin,
        ]

        return(
            <p>
                <FormattedText value={keyTinTae} injectedStrings={injectedStringsTinTae} />
            </p> 
        )
    }
    render() {
        return (
        <div className="contract-input">
            <h5 className="deposit-radio-subtitle">{formatText("contractsView-contractsView_selectedDepositTermSubTitle")}</h5>
            {this.buildLabel()}
        </div>
        )
    }
}

module.exports = ContractLabelDeposit;

ContractLabelDeposit.propTypes = {
    immContract: PropTypes.object.isRequired,
    immDeposits: PropTypes.object,
    immProfile: PropTypes.object,
    localState: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};
